import { render, staticRenderFns } from "./InfoCuponAmigoAsignado.vue?vue&type=template&id=4f1928d3&"
import script from "./InfoCuponAmigoAsignado.vue?vue&type=script&lang=js&"
export * from "./InfoCuponAmigoAsignado.vue?vue&type=script&lang=js&"
import style0 from "./InfoCuponAmigoAsignado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports